import React, { Component } from "react";


export default class BlogContent extends Component {

    constructor(props){
      super(props);

      this.state ={
        blogContent: this.props.blogContent
      }
    }

   render(){
      return(
        <p className="mt-4 line-height-1_8">
            {this.state.blogContent}
        </p>

      );
    }

}



// WEBPACK FOOTER //
// ./src/containers/BlogContent.js